import { TOAST_TYPES } from "@stadium/services/react-toastify/constants";

export const MessageComponentWithTitle = ({ message, title, type }) => {
  return (
    <div className="Toastify__toast-body">
      <div
        className={`Custom_Toastify__toast-title ${type === TOAST_TYPES.success ? "successTitle" : ""
          } ${type === TOAST_TYPES.error ? "errorTitle" : ""}`}
      >
        {title}
      </div>
      <div className="Custom_Toastify__toast-message">{message}</div>
    </div>
  );
};
